export default __webpack_public_path__ + "static/media/suwani.1bd9e468.jpg";